export default __webpack_public_path__ + "static/media/sup-blue.396687d0.svg";